<template>
  <RappresentanteDialogCore
    ref="changeCore"
    :modelValue="modelValue"
    :creationStep="creating"
    :available="available"
    :clienti="clienti"
    :contratti="contratti"
    mode="change"
    @update:modelValue="onVisibleChange"
    @saved="$emit('saved', $event)"
    @create-requested="openCreate"
  >
    <template #creation-step>
      <CreaRappresentanteForm
        v-if="creating"
        :modelValue="true"
        :available="available"
        :initialIdentifier="identifierToCreate"
        embedded
        @update:modelValue="onCreateCancelled"
        @created="onCreated"
      />
    </template>
  </RappresentanteDialogCore>
</template>

<script>
import RappresentanteDialogCore from './RappresentanteDialogCore.vue'
import CreaRappresentanteForm from '@/components/form/CreaRappresentanteForm.vue'

export default {
  components: { RappresentanteDialogCore, CreaRappresentanteForm },
  props: {
    modelValue: Boolean,
    available: Boolean,
    clienti: { type: Array, required: true },
    contratti: { type: Array, default: () => [] }
  },
  emits: ['update:modelValue', 'saved', 'created'],
  data() { return { creating: false, identifierToCreate: '' } },
  watch: {
    modelValue(visible) { if (!visible) this.creating = false }
  },
  methods: {
    openCreate(identifier) {
      this.identifierToCreate = identifier
      this.creating = true
    },
    onCreateCancelled() {
      this.$refs.changeCore.resetSearch()
      this.identifierToCreate = ''
      this.creating = false
    },
    onVisibleChange(visible) {
      if (!visible) this.creating = false
      this.$emit('update:modelValue', visible)
    },
    async onCreated(result) {
      await this.$refs.changeCore.useCreatedRepresentative(result)
      this.creating = false
      this.$emit('created', result)
    }
  }
}
</script>
